import CardPicker from '@elements/CardPicker/CardPicker';
import type { CardOption } from '@elements/CardPicker/index';

interface FeaturesSectionProps {
    title?: string;
    features?: CardOption[];
}

const defaultFeatures: CardOption[] = [
    {
        value: '1',
        title: 'Feature 1',
        description: 'Description of feature 1',
        icon: '',
    },
    {
        value: '2',
        title: 'Feature 2',
        description: 'Description of feature 2',
        icon: '',
    },
    {
        value: '3',
        title: 'Feature 3',
        description: 'Description of feature 3',
        icon: '',
    },
];

export const FeaturesSection = ({
    title = 'Our Features',
    features = defaultFeatures,
}: FeaturesSectionProps) => {
    return (
        <section className="container mx-auto px-4 py-20">
            <h2 className="text-4xl font-bold text-center mb-12">{title}</h2>
            <CardPicker 
                name="features" 
                options={features} 
                onChange={() => {}} 
                columns={3}
            />
        </section>
    );
}
